import { apiClient } from '@/services/base'
import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { IBasicInfoRequest } from './interfaces/request'
import { IBasicInfoResponse } from './interfaces/response'

export const BasicInfoService = async (
  request: IBasicInfoRequest,
): Promise<IBasicInfoResponse> => {
  const response = await apiClient.post('api/login/basicInfoAsync', request, {
    baseURL: process.env.NEXT_PUBLIC_API_BACKEND_URL,
  })

  return response?.data
}

export const useBasicInfoService = (): UseMutationResult<
  IBasicInfoResponse,
  Error,
  IBasicInfoRequest
> => {
  return useMutation<IBasicInfoResponse, Error, IBasicInfoRequest>({
    mutationFn: async (request) => {
      const response = await apiClient.post('api/login/basicInfoAsync', request)

      return response.data
    },
  })
}

export type { IBasicInfoRequest, IBasicInfoResponse }
